module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/user_one-bc1c2c3c5efd63bb14d9d161a848d45a.png";